<template>
    <b-container fluid>
        <b-row>
            <b-col cols="6" class="py-2">
                <label for="title">Filtrar por nombre o palabras clave</label>
                <app-form-input
                    type="text"
                    size="sm"
                    id="name"
                    v-model="filters.name"
                ></app-form-input>
            </b-col>
            <b-col cols="6" class="right-spaced mt-4">
                <b-btn variant="primary" title="filtrar" @click="filter">
                    <i class="fa fa-filter"></i>
                </b-btn>
                <b-btn variant="secondary" title="limpiar" @click="clear">
                    <i class="fa fa-times"></i>
                </b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
        },
    }),
    methods: {
        filter() {
            this.$emit('filter', this.filters)
        },
        clear() {
            this.filters.name = ''
            this.$emit('clear')
        },
    },
}
</script>
